// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"3":"a25e52b6","91":"bf96c184","143":"775ee3f7","367":"59a2322d","464":"1f5d7063","487":"6554f693","897":"4d4f83cf"}[chunkId] + ".css";
};